import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { closeSidebarBeforeRemoveEpic } from './_epics/closeSidebarBeforeRemove.epic';
import { redirectOnSelectedNodeRemovedEpic } from './_epics/redirectOnSelectedNodeRemoved.epic';

export const controllerStreamEpic = safeCombineEpics(
  closeSidebarBeforeRemoveEpic,
  redirectOnSelectedNodeRemovedEpic,
);
